/*
 * The pages one tap away from the product page, fetched once the line is quiet.
 *
 * 2026-10-01: a `webpackPrefetch` hint put <link rel=prefetch> for the shop, the
 * checkout and the order-placed chunks in the head, and on a 4G line they shared
 * the bandwidth with the main script and the Hebrew strings — the buy button
 * paid a second for pages nobody was on. They are asked for after `load`, once
 * every picture the page asked for has arrived and nothing new has been asked
 * for in a while (utils/afterPageLoad), which is also when the pixel goes.
 */
import { afterPageLoad } from "./afterPageLoad";

const loaders = [
  () => import("../Pages/Shop"),
  () => import("../Pages/Checkout"),
  () => import("../Pages/Checkout/OrderPlaced"),
];
let asked = false;

export function prefetchShopperPages() {
  if (asked) return;
  asked = true;
  afterPageLoad(() => { loaders.forEach((load) => { try { load().catch(() => {}); } catch (_) { /* a chunk that cannot be asked for now is asked for on the tap */ } }); });
}
